import React, { Component } from 'react';
import './VIDsList.css';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';
import _ from 'lodash';
import IconContainer from '../../commonComponents/iconContainer/IconContainer';
import { sharedLabelsPath } from "../../../reducers/common/localization";
import {Utils} from "../../../utils/utils";
import { EXPOSE_NID_OPTIONS } from '../../../constants/constants';
import Select from 'react-select';

const customStyles = {
    container: provided => ({
        ...provided,
        maxWidth: 300
    }),
    option: (provided, state) => ({
        ...provided,
        ":hover": {
            backgroundColor: state.isSelected ? '#89aa11' : 'rgba(137, 170, 17, 0.44)'
        },
        backgroundColor: state.isSelected ? '#89aa11' : 'white',
        cursor: 'pointer',
        fontSize: '.9rem',
        paddingTop: '0',
        paddingBottom: '0',
        textOverflow: 'ellipsis',
        overflow: 'hidden'
    }),
    control: (provided, state) => ({
        ...provided,
        fontSize: '.875rem',
        cursor: 'pointer',
        minHeight: 'calc(1.5em + .5rem + 2px)',
        height: 'calc(1.5em + .5rem + 2px)',
        border: '1px solid #ced4da',
        ":hover": {
            border: '1px solid #ced4da',
        },
        borderColor: state.isFocused ? '#80bdff' : '#ced4da',
        boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(0,123,255,.25)' : 'none',
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        padding: '0 5px 0 0'
    }),
    indicatorSeparator: () => ({
        display: 'none'
    }),
    menu: styles => ({
        ...styles,
        marginTop: '0',
        marginBottom: '0',
        borderRadius: '0'
    }),
    menuList: styles => ({
        ...styles,
        paddingTop: '0',
        paddingBottom: '0'
    })
};

class VIDsList extends Component {
    componentDidMount() {
        this.props.onGetVIDs();
    }

    render() {
        return (
            <div className='vids-list-container'>
                <h4 className="page-label">{_.get(this.props.translation, 'applicant_accreditations_management.vids_label')}</h4>
                {this.renderContent()}
            </div>
        );
    }

    renderContent = () => {
        if (this.props.loading && (_.isNil(this.props.data) || this.props.data.length === 0)) {
            return (
                <div className="vids-status-message-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            );
        }

        if (_.isNil(this.props.data) || this.props.data.length === 0) {
            return (
                <div className="vids-status-message-container">
                    <h6>{Utils.getTagsFromStringWithStyles(_.get(this.props.translation, 'applicant_accreditations_management.no_vids_label'))}</h6>
                </div>
            );
        }

        return (
            <Table className='vids-list-table' cellSpacing="0" key="vids-list-table">
                <thead>
                    <tr>
                        <th>{_.get(this.props.translation, 'applicant_accreditations_management.active_vid_label')}</th>
                        <th>{_.get(this.props.translation, sharedLabelsPath.first_name_label)}</th>
                        <th>{_.get(this.props.translation, sharedLabelsPath.last_name_label)}</th>
                        <th>{_.get(this.props.translation, sharedLabelsPath.national_id_label)}</th>
                        <th>{_.get(this.props.translation, sharedLabelsPath.country_label)}</th>
                        <th className="vid-expose-name-country-header">{_.get(this.props.translation, 'applicant_accreditations_management.expose_fn_ln_country')}</th>
                        <th className="vid-expose-national-id-header">{_.get(this.props.translation, 'applicant_accreditations_management.expose_national_id')}</th>
                    </tr>
                </thead>
                <tbody>
                    {this.renderVIDsData()}
                </tbody>
            </Table>
        );
    };

    renderVIDsData() {
        return _.map(this.props.data, (vid) => (
            <tr key={vid.id} className={"vids-list-row" + (vid.active ? ' active-vid' : '')}>
                <td
                    className='active-vid-td'
                    data-th={_.get(this.props.translation, 'applicant_accreditations_management.active_vid_label') + ":"}
                >
                    <IconContainer
                        className="vid-active-vid-icon"
                        icon={"radio_button" + (!vid.active ? "_unchecked" : "_checked")}
                        key={"vid-active-vid-" + vid.id}
                        onClick={() => {this.props.onActivateVID(vid.id)}}
                        title={_.get(this.props.translation, 'applicant_accreditations_management.active_vid_title_' + (vid.active ? "checked" : "unchecked"))}
                    />
                </td>
                <td
                    className='vid-first-name-td'
                    data-th={_.get(this.props.translation, sharedLabelsPath.first_name_label) + ":"}
                >
                    {vid.firstName}
                </td>
                <td
                    className='vid-last-name-td'
                    data-th={_.get(this.props.translation, sharedLabelsPath.last_name_label) + ":"}
                >
                    {vid.lastName}
                </td>
                <td
                    className='vid-national-id-td'
                    data-th={_.get(this.props.translation, sharedLabelsPath.national_id_label) + ":"}
                >
                    {vid.nationalId}
                </td>
                <td
                    className='vid-country-td'
                    data-th={_.get(this.props.translation, sharedLabelsPath.country_label) + ":"}
                >
                    {_.get(this.props.translation, 'countries.' + vid.countryCode)}
                </td>
                <td
                    className="vid-expose-name-country-icon-container"
                    data-th={_.get(this.props.translation, 'applicant_accreditations_management.expose_fn_ln_country') + ":"}
                >
                    <IconContainer
                        className="vid-expose-name-country-icon"
                        icon={"check_box" + (!vid.exposeNameCountry ? "_outline_blank" : "")}
                        key={"vid-expose-name-country-" + vid.id}
                        onClick={this.onExposeClick("exposeNameCountry", vid.id, vid)}
                        title={_.get(this.props.translation, 'applicant_accreditations_management.expose_fn_ln_country')}
                    />
                </td>
                <td
                    className="vid-expose-national-id-td"
                    data-th={_.get(this.props.translation, 'applicant_accreditations_management.expose_national_id') + ":"}
                >
                    <Select
                        styles={customStyles}
                        options={this.getExposeNIDOptions()}
                        value={this.getExposeNIDSelectedOption(vid)}
                        onChange={this.handleChangeExposeNID(vid.id, vid)}
                        isSearchable={false}
                    />
                </td>
            </tr>
        ));
    }

    getExposeNIDOptions = () => {
        return [
            {value: EXPOSE_NID_OPTIONS.NOT_EXPOSE, label: _.get(this.props.translation, 'applicant_accreditations_management.expose_nid_option_not_expose')},
            {value: EXPOSE_NID_OPTIONS.EXPOSE_SHORT, label: _.get(this.props.translation, 'applicant_accreditations_management.expose_nid_option_short')},
            {value: EXPOSE_NID_OPTIONS.EXPOSE_FULL, label: _.get(this.props.translation, 'applicant_accreditations_management.expose_nid_option_full')}
        ];
    };

    getExposeNIDSelectedOption = (vid) => {
        let selectedElem = _.find(this.getExposeNIDOptions(), elem => elem.value === vid.exposeNationalIdLevel);
        if (_.isNil(selectedElem)) {
            return null;
        }
        return selectedElem;
    };

    onExposeClick = (key, id, vid) => () => {
        let data = vid;

        data[key] = !vid[key];

        this.props.onUpdateVID(id, data);
    };

    handleChangeExposeNID = (id, vid) => (selectedOption) => {
        let data = vid;

        data.exposeNationalIdLevel = selectedOption.value;

        this.props.onUpdateVID(id, data);
    };
}

VIDsList.propTypes = {
    data: PropTypes.array,
    loading: PropTypes.bool,
    translation: PropTypes.object.isRequired,
    onGetVIDs: PropTypes.func.isRequired,
    onUpdateVID: PropTypes.func.isRequired
};

export default VIDsList;



// WEBPACK FOOTER //
// ./src/components/applicantAccreditationsManagement/VIDsList/VIDsList.js